import type { Dayjs } from 'dayjs';

/** The first date the backend is asked for when only a "to" date is chosen (orders before 2024 are not needed). */
export const MIN_DATE_SENTINEL = '2024-01-01';

/**
 * `YYYY-MM-DD` for a date picker value, or `null` while the field is empty or half-typed.
 * MUI's DatePicker reports an invalid Dayjs while the user edits a section; that must never reach the API.
 */
export const dateParam = (value: Dayjs | null | undefined): string | null =>
    value && value.isValid() ? value.format('YYYY-MM-DD') : null;

/** Order ids are numeric everywhere in the panel: keep only digits from what the user typed or pasted. */
export const digitsOnly = (value: string): string => value.replace(/\D+/g, '');
